<script setup lang="ts">
import { Toaster } from '@/components/ui/toast'
</script>
<template>
  <RouterView />
  <Toaster/>
</template>